import React, { useEffect } from 'react';
import { StyledTableContainer } from './AttachChildStyles';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import { attachChildDucksModule, clearState, getAllRequests } from './AttachChildDucks';
import { useDispatch, useSelector } from 'react-redux';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { useTranslation } from 'react-i18next';
import './AttachChildTranslate';
import { requestsColumns } from './AttachChildColumns';
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import AttachChildDialog from './Components/AttachChildDialog';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import i18next from 'i18next';
import Paper from '@material-ui/core/Paper';

function AttachChildWithParent() {
  const data = useSelector(state => state[attachChildDucksModule].data);
  const pageNumber = useSelector(state => state[attachChildDucksModule].pageNumber);
  const loading = useSelector(state => state[attachChildDucksModule].loading);
  const attachChildModal = useSimpleModal();
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_attachChild') }
  ];
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { toPage, filter } = useTableFilter(filter => {
    dispatch(getAllRequests(filter));
  });

  useEffect(() => {
    dispatch(clearState());
  }, []);

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('attachChildTableTitle')}</h3>

        <StyledTableContainer>
          <div className="mt2">
            <StaticTablePaginated
              loading={loading}
              data={data}
              columns={requestsColumns({ t })}
              filterable={false}
              pageSize={20}
              onClickRow={({ row }) => attachChildModal.open({ row })}
              pagePagination={page => {
                if (page !== pageNumber) {
                  toPage(page);
                }
              }}
            />
          </div>
        </StyledTableContainer>
        {attachChildModal.isOpen && (
          <AttachChildDialog
            {...attachChildModal.data}
            open={attachChildModal.isOpen}
            close={attachChildModal.close}
            filter={filter}
          />
        )}
      </Paper>
    </>
  );
}

export default AttachChildWithParent;
